<template>
  <nav
    class="navbar navbar-expand-lg navbar-light bg-light d-flex justify-content-around rounded"
  >
    <i class="bi bi-gear"></i>
    <i
      class="bi bi-plus-lg"
      @click="setAction('neworg')"
      v-if="!store.active_org"
    ></i>
    <i class="bi bi-power text-danger" @click="logout"></i>
  </nav>
</template>
<script setup>
import { getAuth, signOut } from "firebase/auth";
import { useRouter } from "vue-router";
import { useStore } from "../../store/index";
const store = useStore();
const auth = getAuth();
const router = useRouter();
const setAction = (action) => {
  store.setAction(action);
};
const logout = () => {
  signOut(auth)
    .then(() => {
      router.push("/");
    })
    .catch((error) => {
      // An error happened.
      console.log(error);
    });
};
</script>
